import 'amfe-flexible';   //用于rem的适配
import '../rem.js';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';

import axios from 'axios';
import {post,postForm,postUp,fetch,patch,put} from './api/fetch';
Vue.prototype.$post=post;
Vue.prototype.$postForm=postForm;
Vue.prototype.$postUp=postUp;
Vue.prototype.$fetch=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;
//Vue.prototype.Fetch = Fetch;
Vue.use(Vant)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
